import { useCallback, useEffect, useState } from 'react';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CreateIcon from '@mui/icons-material/Create';
import { useStyles } from '../ChapterContent.style';
import { GetChapterContents, DeleteChapterContent } from "../../../DAL/ChaptersContents/contents";
import { GetBookChapters } from "../../../DAL/BooksChapters/bookChapters";
import { enqueueSnackbar } from "notistack";
import { useLocation } from 'react-router-dom';
import { GetBooks } from '../../../DAL/Books/books';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

 const tableCells = [
  { id: 'contentBookId', title: 'Book Name', filterable: true, filterKey: 'BookName' },
  { id: 'bookNoContent', title: 'Book No', filterable: true, filterKey: 'BookNo' },
  { id: 'chapterId', title: 'Chapter Name', filterable: true, filterKey: 'chapterName' },
  { id: 'chapterNoContent', title: 'Chapter No', filterable: true, filterKey: 'chapterNo' },
  { id: 'pageNo', title: 'Page No', filterable: true, filterKey: 'pageNo' },
  { id: 'content', title: 'Content', filterable: true, filterKey: 'content' },
  { id: 'url', title: 'Url', filterable: false },
  { id: 'actions', title: 'Action(s)', filterable: false },
];

export const useContent = () => {
  const classes = useStyles();
  const query = useQuery();
  const chapterId = query.get('chapterId');
  
  const [ContentData, setContentData] = useState([]);
  const [ContentCount, setContentCount] = useState(0);
  const [bookData, setBookData] = useState([])
  const [selectedBookId, setSelectedBookId] = useState("")
  const [chapterData, setChapterData] = useState([])
  const [singleContent, setsingleContent] = useState('');
  const [open, setOpen] = useState(false);
  const [orderModal, setOrderModal] = useState(false);
  const [action, setAction] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false)
  const [searchKey, setSearchKey] = useState("pageNo")
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerContent, setDrawerContent] = useState('');

  const initializeFilters = (cells) => {
  const obj = {};
  cells.forEach((cell) => {
    if (cell.filterable) obj[cell.id] = '';
  });
  return obj;
};

const [filters, setFilters] = useState(() => initializeFilters(tableCells));

 
  const actionsIcons = [
    { icon: <DeleteOutlineOutlinedIcon className={classes.iconStyle} />, action: "delete" },
    { icon: <CreateIcon className={classes.iconStyle} />, action: "edit" },
  ];

  useEffect(() => {
    getContentsData(page, limit, filters, chapterId);
  }, [filters, page, limit, search, chapterId]);

//   useEffect(() => {
//   const activeFilters = Object.entries(filters).filter(([_, v]) => v !== '');

//   if (activeFilters.length === 1) {
//     // If only one filter is active, use that
//     const [key, value] = activeFilters[0];
//     getContentsData(page, limit, value, key, chapterId);
//   } else if (activeFilters.length === 0) {
//     // If no filters, call with empty search
//     getContentsData(page, limit, '', '', chapterId);
//   }
//   // You may decide what to do if multiple filters are active (e.g., send all in params or block)
// }, [filters, page, limit, chapterId]);

  useEffect(() => {
    getBooksData()
  }, [])


  const getMappedFilters = (filters, tableCells) => {
  const mappedFilters = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== '') {
      const matchedCell = tableCells.find(cell => cell.id === key);
      if (matchedCell && matchedCell.filterKey) {
        mappedFilters[matchedCell.filterKey] = value;
      }
    }
  });
  return mappedFilters;
};
  
  const getContentsData = useCallback(async(page, limit, filters, chapterId) => {
    const mappedFilters = getMappedFilters(filters, tableCells);
    
    setIsLoading(true)
   let data = {
  page: Math.max(page + 1, 1),
  limit: limit,
  filters: mappedFilters,
  chapterId: chapterId || ""
}
    const response = await GetChapterContents(data);
        if (response.statusCode == 200) {
          setIsLoading(false);
          setContentData(response?.data?.rows);
          setContentCount(response?.data?.count);
    
        } else {
          setIsLoading(false);
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, [chapterId, filters, enqueueSnackbar]);


  
  const getBooksData = useCallback(async() => {
      let data = false
      const response = await GetBooks(data);
          if (response.statusCode == 200) {  
            const bookRes = response?.data?.rows?.map(item => ({
                value: item.id,
                text: item.bookName
              }));  
              setBookData(bookRes);
          } else {
            if (typeof response.message == "string") {
              enqueueSnackbar(response.message, { variant: "error" });
            } else {
              enqueueSnackbar("Invalid credentials", { variant: "error" });
            }
          }
    }, []);

    const getBookChaptersData = useCallback(async(bookId) => {
        let data = { bookId: bookId }
        const response = await GetBookChapters(data);
            if (response.statusCode == 200) {
              const chapterRes = response?.data?.rows?.map(item => ({
                value: item.id,
                text: item.chapterName
              }));
              setChapterData(chapterRes);
            } else {
              if (typeof response.message == "string") {
                enqueueSnackbar(response.message, { variant: "error" });
              } else {
                enqueueSnackbar("Invalid credentials", { variant: "error" });
              }
            }
      }, []);

  const handleDelete = useCallback(async(id) => {
    const response = await DeleteChapterContent(id); 
        if (response.statusCode == 200) {
          // getContentsData(page, limit, search, searchKey, chapterId)
          getContentsData(page, limit, filters, chapterId);
        } else {
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, []);

  const handleAdd = useCallback(() => {
    setAction('add');
    setOpen(true);
  }, []);

  const handleActionClick = useCallback((index, row) => {
    
    setSelectedBookId(row?.Chapter?.bookId)
    setsingleContent({...row, contentBookId: row?.Chapter?.bookId });
    getBookChaptersData(row?.Chapter?.bookId)
    // dispatch(getsingleContentOrderData(row));
    if (index === 0) {
      setAction('delete');
      handleDelete(row.id);
    }
    if (index === 1) {
      setAction('update');
      setOpen(true);
    }
  }, []);

  const handleChangePage = useCallback((isTrue, newPage) => {
  if (isTrue) {
    setPage(Math.max(newPage - 1, 0));
  } else {
    setPage(Math.max(newPage, 0));
  }
}, []);

  const handleChangeRowsPerPage = useCallback(event => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  const calculatePagesCount = (pageSize, totalCount) => {
    return totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
  };

  const handleContentSearch = useCallback(value => {
    setSearch(value);
    setPage(0);
    setLimit(10);
  }, []);

  const handleDropDown = useCallback(value => {
        setSearchKey(value);
        if(search) {
        // getContentsData(0, 10, search, value, chapterId);
        getContentsData(0, 10, filters, chapterId);
        }
      }, []);

  const handleGetContentData = useCallback(value => {
    // getContentsData(page, limit, search, searchKey, chapterId)
    getContentsData(page, limit, filters, chapterId);
  }, [filters]);

 const handleBookGetChapter = (event) => {
    setSelectedBookId(event?.target?.value)
    getBookChaptersData(event?.target?.value)
  };

  const handleFilterChange = (key, value) => {
  setFilters((prev) => ({ ...prev, [key]: value }));
  setPage(0);  // Optional: Reset to first page on filter change
};



  const handleContentClick = (content, row) => {
    console.log("===========row======++>>>>>>>>>", row);
    setDrawerContent({content: content, language: row?.Chapter?.Book?.Language});
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setDrawerContent('');
  };
  
  return {
    ContentData,
    ContentCount,
    singleContent,
    open,
    orderModal,
    action,
    tableCells,
    actionsIcons,
    page,
    limit,
    isLoading,
    chapterData,
    bookData,
    searchKey,
    selectedBookId,
    filters,
    drawerOpen,
    drawerContent,
    setOpen,
    setOrderModal,
    handleGetContentData,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
    handleContentSearch,
    handleDropDown,
    handleBookGetChapter,
    handleFilterChange,
    handleContentClick,
    handleCloseDrawer,
  };
};
